// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"RU","mainContent":"SU","activeSidebar":"TU","hydraPills":"UU"};